import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_administration/settings/facilities")({
  beforeLoad: ({ context }) => guardRoute(context.me, "facilities"),
  component: Outlet,
});
